import { createFileRoute } from '@tanstack/react-router';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { TaxWithholdingSettingsPage } from '@mews-commander/modules/src/modules/accountingConfiguration';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute(
    '/_authenticated/$currentEnterpriseId/Settings/AccountingConfiguration/TaxWithholding'
)({
    component: () => <TaxWithholdingSettingsPage />,
    beforeLoad: ({ context: { checkFeatureFlag } }) => {
        checkFeatureFlag(FeatureFlag.taxwithholdingConfigurationPage);
    },
    staticData: {
        owner: MewsTeam.Billing,
        title: TextKey.TaxWithholdingTabTitle,
        type: RouteType.Frontend,
        excludeBreadcrumb: true,
    },
});
